module.exports = __webpack_public_path__ + "static/media/payment-visa.77234ad7.png";